import { render, staticRenderFns } from "./internal.vue?vue&type=template&id=72898574&scoped=true"
import script from "./internal.vue?vue&type=script&lang=js"
export * from "./internal.vue?vue&type=script&lang=js"
import style0 from "./internal.vue?vue&type=style&index=0&id=72898574&prod&lang=scss"
import style1 from "./internal.vue?vue&type=style&index=1&id=72898574&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72898574",
  null
  
)

export default component.exports